export const TelemedicineRoutesPaths = {
  TELEMEDICINE_PLAN_OVERVIEW: '/telemedicine-product-overview',
  TELEMEDICINE_OPERATION_DETAILS: '/telemedicine-operation-overview',
  TELEMEDICINE_OTP: '/telemedicine-otp',
  TELEMEDICINE_OPERATION_OVERVIEW: '/telemedicine-operation-details'
};
